import { Filter } from '@anytag/shared-molecules';
import { Template } from './Template';
import { useMarketplaceAutoManagedCampaignFilter } from './hooks';

export const MarketplaceAutoManagedCampaignFilter = () => {
  const { filter, setFilterForm } = useMarketplaceAutoManagedCampaignFilter();

  return (
    <Filter.Provider onSubmit={setFilterForm} values={filter} className="p-6 pb-4">
      <Template />
    </Filter.Provider>
  );
};

export { useMarketplaceAutoManagedCampaignFilter };
export * from './schemaTypes';
